import { combineReducers } from "@reduxjs/toolkit";

import commonReducer from "./slice";
import authReducer from "../modules/auth/stores/slice";
import driverReducer from "../modules/driver/stores/slice";
import orderReducer from "../modules/order/stores/slice";
import groupReducer from "../modules/group/stores/slice";
import settingReducer from "../modules/setting/stores/slice";
import routePlanReducer from "../modules/routePlan/stores/slice";
import companyReducer from "../modules/company/stores/slice";
import companyAdminReducer from "../modules/companyAdmin/stores/slice";
import userReducer from "../modules/user/stores/slice";
import liveTrackingReducer from "../modules/liveTracking/stores/slice";
import messageLogReducer from "../modules/messageLog/stores/slice";
import partnerReducer from "../modules/partner/stores/slice";
import labelReducer from "../modules/label/stores/slice";
import contactReducer from "../modules/contact/stores/slice";
import reportReducer from "../modules/report/stores/slice";

const appReducer = combineReducers({
  common: commonReducer,
  auth: authReducer,
  driver: driverReducer,
  order: orderReducer,
  group: groupReducer,
  setting: settingReducer,
  routePlan: routePlanReducer,
  company: companyReducer,
  companyAdmin: companyAdminReducer,
  user: userReducer,
  liveTracking: liveTrackingReducer,
  messageLog: messageLogReducer,
  partner: partnerReducer,
  label: labelReducer,
  contact: contactReducer,
  report: reportReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "auth/doLogout") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
